import * as React from 'react'

import DynamicComponent from '@/components/DynamicComponent'
import HeadComponent from '@/components/HeadComponent'
import Layout from '@/templates/Layout'

const Page = ({pageContext: story}) => {
  const {components = []} = story

  return (
    <Layout story={story}>
      {components.map((props, index, components) => {
        return (
          <DynamicComponent
            key={props._uid}
            index={index}
            components={components}
            story={story}
            {...props}
          />
        )
      })}
    </Layout>
  )
}

export const Head = ({pageContext}) => <HeadComponent {...pageContext} />

export default Page
